(() => {
  const source = document.querySelector('[data-shp-search-switch-source]');
  const headerSearches = [...document.querySelectorAll('.header__search')];
  if (!source || !headerSearches.length) return;
  document.documentElement.classList.add('shp-search-switch-ready');
  let iconVisible = false;
  let ticking = false;
  const setIconVisible = (visible) => {
    if (iconVisible === visible) return;
    iconVisible = visible;
    headerSearches.forEach((search) => {
      const summary = search.querySelector('summary');
      const details = search.querySelector('details');
      search.classList.toggle('shp-search-icon--visible', visible);
      search.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (summary) summary.tabIndex = visible ? 0 : -1;
      if (!visible && details) details.removeAttribute('open');
    });
  };
  const update = () => {
    ticking = false;
    const headerBottom = document.querySelector('.section-header')?.getBoundingClientRect().bottom || 0;
    const sourceBottom = source.getBoundingClientRect().bottom;
    // Switching never changes the source's layout. A dead band prevents jitter.
    if (!iconVisible && sourceBottom < headerBottom - 12) setIconVisible(true);
    else if (iconVisible && sourceBottom > headerBottom + 12) setIconVisible(false);
  };
  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  window.addEventListener('pageshow', requestUpdate);
  document.addEventListener('shopify:section:load', requestUpdate);
  update();
})();
